export const GET_GENERATOR_UPWINDBEARING_RESULT   = "GET_GENERATOR_UPWINDBEARING_RESULT";
export const GET_GENERATOR_DOWNWINDBEARING_RESULT = "GET_GENERATOR_DOWNWINDBEARING_RESULT";
export const GET_GENERATOR_UPWINDBEARING_SUCCESS = "GET_GENERATOR_UPWINDBEARING_SUCCESS";
export const GET_GENERATOR_DOWNWINDBEARING_SUCCESS = "GET_GENERATOR_DOWNWINDBEARING_SUCCESS";
export const GET_GENERATOR_ROLLING_BEARING_RESULT_ERROR = "GET_GENERATOR_ROLLING_BEARING_RESULT_ERROR";
export const RESET_GENERATOR_ROLLING_BEARING_RESULT = "RESET_GENERATOR_ROLLING_BEARING_RESULT";
